import { AuthForm } from '@/components/forms/new-form';
import { Container } from '@/components/container';
import { Heading } from '@/components/heading';
import { PageHeader } from '@/components/page-header';

import css from './basement-section.module.scss';

const currentYear = new Date().getFullYear();

const BasementSection = () => {
  return (
    <section className={css.section}>
      <Container>
        <div className={css.basementSection}>
          <PageHeader />
          <div>
            <Heading className={css.basementHeading} type="basement">
              Начать
            </Heading>
            <AuthForm className={css.basementAuthForm} />
          </div>
          <footer className={css.footer}>
            <div>amoCRM @ 2009-{currentYear}. Все права защищены.</div>
          </footer>
        </div>
      </Container>
    </section>
  );
};

export default BasementSection;
